export const promiseTimeout = (response, timer) => new Promise((resolve) => {
    setTimeout(() => {
        resolve(response);
    }, timer);
});
